







































































import Vue from 'vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import { GroupModel } from '@descomplica/dex-models';
import draggable from 'vuedraggable';
import PanVerticalIcon from 'vue-material-design-icons/SwapVertical.vue';

export default Vue.extend({
  components: {
    pxButton,
    pxModal,
    draggable,
    PanVerticalIcon,
  },

  props: {
    entities: {
      type: Object,
      required: true,
    },
    courseId: {
      type: Number,
      required: true,
    },
    managedEntity: {
      type: Object,
      required: true,
    },
    managedEntityType: {
      type: String,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    grouplessCourseBoards: {
      type: Array,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      name: null,
      description: null,
      grouplessBoardsToAdd: [],
      isLoading: false,
      orderedGroups: this.groups,
    };
  },

  computed: {
    mutableItems: {
      get(): Array<GroupModel> {
        return this.orderedGroups;
      },
      set(sortedItems: Array<GroupModel>) {
        this.orderedGroups = sortedItems;
      },
    },
  },

  mounted() {
    if (this.isEditing) {
      this.name = this.managedEntity.name;
      this.description = this.managedEntity.description;
    }
  },

  methods: {
    chooseEntityMethods(entityType: 'group' | 'boardsGroup') {
      return entityType === 'boardsGroup'
        ? { create: this.createBoardsGroup, edit: this.editBoardsGroup }
        : { create: this.createGroup, edit: this.editGroup };
    },
    async createBoardsGroup() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        const response = await this.$store.dispatch('CREATE_BOARDS_GROUP', {
          courseId: this.courseId,
          name: this.name.trim(),
          description: this.description && this.description.trim(),
        });

        this.$store.commit(
          'UPDATE_BOARDS_GROUPS_ENTITY',
          response.data.createBoardsGroup,
        );
      } catch (err) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${err}`,
        );
      }

      this.isLoading = false;
      this.$emit('toggleModalDisplay');
    },
    async editBoardsGroup() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        const response = await this.$store.dispatch('UPDATE_BOARDS_GROUP', {
          boardsGroupId: this.managedEntity.id,
          boardsGroupInfo: {
            name: this.name.trim(),
            description: this.description && this.description.trim(),
          },
        });

        this.mutableItems.map(async (group: GroupModel, position: number) => {
          await this.$store.dispatch('UPDATE_GROUP', {
            groupId: group.id,
            groupInfo: { position },
          });
          this.$store.commit('UPDATE_GROUP_ENTITY', {
            ...group,
            position,
          });
        });

        this.$store.commit(
          'UPDATE_BOARDS_GROUPS_ENTITY',
          response.data.updateBoardsGroup,
        );
      } catch (err) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${err}`,
        );
      }

      this.isLoading = false;
      this.$emit('toggleModalDisplay');
    },
    async createGroup() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        const response = await this.$store.dispatch(
          'CREATE_GROUP_IN_BOARDSGROUP',
          {
            boardsGroupId: this.managedEntity.id,
            groupInfo: {
              name: this.name.trim(),
              description: this.description && this.description.trim(),
              boardIds: this.grouplessBoardsToAdd,
            },
          },
        );

        this.$store.commit(
          'UPDATE_GROUP_ENTITY',
          response.data.createGroupByBoardsGroupId,
        );
      } catch (err) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${err}`,
        );
      }

      this.isLoading = false;
      this.$emit('toggleModalDisplay');
    },
    async editGroup() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        const response = await this.$store.dispatch('UPDATE_GROUP', {
          groupId: this.managedEntity.id,
          groupInfo: {
            name: this.name.trim(),
            description: this.description && this.description.trim(),
          },
        });

        this.$store.commit('UPDATE_GROUP_ENTITY', response.data.updateGroup);
      } catch (err) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${err}`,
        );
      }

      this.isLoading = false;
      this.$emit('toggleModalDisplay');
    },
  },
});
